import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashBoardService } from 'src/app/service/dashboard.service';
import { AssignMeterService } from '../../service/assignmeter.service';

@Component({
  selector: 'app-update-parameter',
  templateUrl: './update-parameter.component.html'
})
export class UpdateParameterComponent implements OnInit {

  // Property Declaration
  setparameterForm: FormGroup;
  MeterValue: any;
  UnitRate: string = '';
  PowerFactorPenalty: string = '';
  errorMsg: string = '';
  DeviceId: string = '';
  IsreadOnly1: boolean = false;
  UserId: number;
  successMsg: string;

  constructor(private form: FormBuilder, private dashboardservice: DashBoardService, private dialog: MatDialog, public dialogRef: MatDialogRef<UpdateParameterComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private assignmeterservice: AssignMeterService) {
    dialogRef.disableClose = true;
    if (data && data.DeviceId) {
      this.DeviceId = data.DeviceId;
    }
  }

  ngOnInit(): void {
    this.UserId = +localStorage.getItem('UserId');
    this.setparameterForm = this.form.group({
      ThresholdEnergy: [''],
      ThresholdTemperature: [''],
      ThresholdHumidity: [''],
      ThresholdMDI: [''],
      ThresholdPowerFactor: [''],
      ThresholdElectricityBill: ['']
    });

    this.GetMeterValues();
  }

  // Set Parameter Values
  GetMeterValues() {

    this.assignmeterservice.GetMeterParamValue(this.DeviceId).subscribe(
      (result) => {
        if (result) {
          this.MeterValue = result;
          this.setparameterForm.patchValue({
            ThresholdEnergy: this.MeterValue.ThresholdEnergy,
            ThresholdTemperature: this.MeterValue.ThresholdTemperature,
            ThresholdHumidity: this.MeterValue.ThresholdHumidity,
            ThresholdMDI: this.MeterValue.ThresholdMDI,
            ThresholdPowerFactor: this.MeterValue.ThresholdPowerFactor,
            ThresholdElectricityBill: this.MeterValue.ThresholdElectricityBill
          });
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Call on click Save button
  OnSubmit(): void {
    this.successMsg = '';
    this.errorMsg = '';
    var Setparamvalue = { ...this.setparameterForm.value };

    var ReqObj = {
      EnergyMeterID: this.DeviceId,
      UserId: this.UserId,
      ThresholdEnergy: Setparamvalue.ThresholdEnergy,
      ThresholdTemperature: Setparamvalue.ThresholdTemperature,
      ThresholdHumidity: Setparamvalue.ThresholdHumidity,
      ThresholdMDI: Setparamvalue.ThresholdMDI,
      ThresholdPowerFactor: Setparamvalue.ThresholdPowerFactor,
      ThresholdElectricityBill: Setparamvalue.ThresholdElectricityBill
    };

    this.dashboardservice.UpdateMeterParamValue(ReqObj).subscribe(
      (result) => {
        if (result.Response == 'success') {
          this.successMsg = 'Values submitted successfully';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
    // this.dialogRef.close(ReqObj);
  }

  // Call on click Cancel button
  OnCancel() {
    this.dialogRef.close();
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }
}
